/**
 * FPS Manager class.
 */
class FPSManager {

    constructor( args = {} ) {
        this.pn = performance.now;
        this.fps = args.fps || 60;
        this.fpsInterval = 1000 / this.fps;
        this.startAt = this.now();
        this.currentAt = null;
        this.elapsed = null;
    }

    now() {
        return ( this.pn && this.pn.call( performance ) ) || ( new Date().getTime() );
    }

    elapse() {
        this.currentAt = this.now();
        this.elapsed = this.currentAt - this.startAt;
    }

    initStartAt() {
        this.startAt = this.currentAt - ( this.elapsed % this.fpsInterval );
    }

    isArrived() {
        return ( this.elapsed >= this.fpsInterval );
    }

    tick( callback ) {
        this.elapse();

        if ( ! this.isArrived() ) {
            return;
        }

        this.initStartAt();
        callback();
    }
}

export default FPSManager;
